<template>
  <div class="root" >
    <iframe :style="{ height }" class="frame" scrolling="no" :srcdoc="html" @load="onLoadFrame" />
  </div>

</template>

<script>
export default {
  name: 'html-iframe',
  props: {
    html: { type: String }
  },
  data () {
    return {
      height: 0
    }
  },
  methods: {
    onLoadFrame (event) {
      const object = event.target
      this.height = object.contentWindow.document.documentElement.scrollHeight + 'px'
    }
  }
}
</script>

<style scoped lang="stylus">
  .root {
    position relative
    //&::before {
    //  content ''
    //  position absolute
    //  top 0
    //  left 0
    //  bottom 0
    //  right 0
    //}
  }
  .frame {
    overflow hidden
    width 100%
    pointer-events:none;
  }
</style>
